import { assign, createMachine } from "xstate";
import { generatePassword } from "@nju/data-access-portal-user";
import { isError } from "@nju/result";

interface IContext {
  password?: string;
  productId?: string;
}

type IEvent =
  | {
      type: "GENERATE_PASSWORD";
    }
  | {
      type: "SUCCESS";
      password: string;
    }
  | { type: "ERROR" };

export const generatePasswordMachine = createMachine(
  {
    schema: {
      context: {} as IContext,
      events: {} as IEvent,
    },
    initial: "init",
    states: {
      init: {
        on: {
          GENERATE_PASSWORD: {
            target: "send",
          },
        },
      },
      send: {
        invoke: {
          src: "getPassword",
        },
        on: {
          SUCCESS: {
            actions: "setGeneratePassword",
            target: "success",
          },
          ERROR: {
            target: "error",
          },
        },
      },
      success: {
        type: "final",
      },
      error: {
        type: "final",
      },
    },
  },
  {
    actions: {
      setGeneratePassword: assign<IContext, IEvent>((context, event) => {
        if (event.type === "SUCCESS") {
          return {
            password: event.password,
          };
        }
        return context;
      }),
    },
    services: {
      getPassword: ({ productId }) => {
        return async (callback) => {
          if (!productId) {
            return callback({ type: "ERROR" });
          }

          const result = await generatePassword(productId);

          if (isError(result)) {
            return callback({ type: "ERROR" });
          }

          return callback({
            type: "SUCCESS",
            password: result.value.password,
          });
        };
      },
    },
  },
);
